export const clearAppModulesResponse = (
    response = [],
    appCode = ''
) => {
    const appConfig = appConfiguration[appCode]
    const itemsToInclude = appConfig?.itemsToInclude || []
    const itemsToExclude = appConfig?.itemsToExclude || []

    const elementsFiltered = response.filter(({code}) => !itemsToExclude.includes(code))
    const elementsToAdd = itemsToInclude.map(item => ({
        id: item.toLocaleLowerCase(),
        title: item
    }))

    const output = elementsFiltered.map(({code}) => ({
        id:code,
        title: code.replace('lang', '')
    }))

    // Eliminar elementos con id repetido
    const uniqueOutput = output.filter((item, index, self) =>
        index === self.findIndex((t) => t.id === item.id)
    );

    return  [...uniqueOutput, ...elementsToAdd]
}

const appConfiguration = {
    'PARK':{
        'itemsToInclude': ['Country'],
        'itemsToExclude': ['lang','langSlide','langAwards'],
    }, 'HCDP':{
        'itemsToInclude': ['Country'],
        'itemsToExclude': ['lang', 'langContact', 'langAfiClass', 'langRestaurantDetails'],
    }, 'HOTEL':{
        'itemsToInclude': ['Country'],
        'itemsToExclude': ['lang'],
    }, 'FERRY':{
        'itemsToInclude': ['Country'],
        'itemsToExclude': ['lang'],
    }, 'EVENTS':{
        'itemsToInclude': ['Country'],
        'itemsToExclude': ['lang'],
    }, 'XKYNET':{
        'itemsToInclude': ['Country'],
        'itemsToExclude': ['lang'],
    }
}